import staffModule from "./modules/staff/index.js";
import userModule from "./modules/user/index.js";
import receiptModule from "./modules/receipt/index.js";
import deviceModule from "./modules/device/index.js";
import loggedModule from "./modules/logged/index.js";
import statisticsModule from "./modules/statistics/index.js";
import userAccountModule from "./modules/userAccount/index.js";
import { isSignedIn, getToken } from "../utils/session";

// Declared here rather than in index.js so that the reset mutation can rebuild a
// pristine tree without importing the store it is part of.
export const modules = {
  staff: staffModule,
  user: userModule,
  receipt: receiptModule,
  device: deviceModule,
  logged: loggedModule,
  statistics: statisticsModule,
  userAccount: userAccountModule,
};

export function rootState() {
  return {
    token: getToken() || "",
    status: "",
    counters: null,
    error: null,
    isLoggedIn: isSignedIn(),
  };
}

// Every module already declares its state as a factory, so a pristine copy of the
// whole tree is just those factories run again. Read the session as it is now: a
// reset that follows a sign out comes back signed out, one that follows a sign in
// comes back as the new user.
export function pristineState() {
  const state = rootState();
  Object.keys(modules).forEach((name) => {
    state[name] = modules[name].state();
  });
  return state;
}
